/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  account: "Account",
  accountBalance: "Account balance",
  accountDetails: "Account details",
  accountIdentification: "Account identification",
  accountNotFound: "Account not found",
  accountNumber: "Account number",
  accountOwner: "Account owner",
  accounts: "Accounts",
  accountsHaveBeenSettled: "Accounts have been settled",
  accountType: "Account type",
  active: "Active",
  address: "Address",
  amount: "Amount ({{currency}})",
  approved: "Approved",
  areYouSureYouWantToDeactivateThisVirtualIban:
    "Are you sure you want to deactivate this virtual IBAN?",
  areYouSureYouWantToDisableNotifications:
    "Are you sure you want to disable notifications?",
  areYouSureYouWantToSettleAllAccounts:
    "Are you sure you want to settle all accounts?",
  areYouSureYouWantToSettleThisAccount:
    "Are you sure you want to settle this account?",
  availableFunds: "Available funds",
  backToAllAccounts: "Back to all accounts",
  balanceAfter: "Balance after",
  balanceCurrency: "Balance ({{currency}})",
  bounceBack: "Bounce back",
  bsb: "BSB",
  closedLoopPayout: "Closed loop payout",
  completed: "Completed",
  configuration: "Configuration",
  connected: "Connected",
  connectMatching: "Connect Matching",
  country: "Country",
  created: "Created",
  dateWhenTheTransactionWasCreated: "Date when the transaction was created",
  dateWhenTheTransactionWasProcessed: "Date when the transaction was processed",
  deactivate: "Deactivate",
  deactivated: "Deactivated",
  deactivateVirtualIban: "Deactivate virtual IBAN",
  disableNotification: "Disable notification",
  email: "Email",
  failed: "Failed",
  givenAccountCouldNotBeFound: "Given account could not be found",
  iban: "IBAN",
  ifYouAreIntegratedWithTheGlobalPayoutAPI:
    "If you are integrated with the Global Payout API, this configuration allows you to receive notifications for all types of payments processed on Volt Accounts, including incoming and outgoing payments.",
  ignored: "Ignored",
  inactive: "Inactive",
  incoming: "Incoming",
  inPayout: "In payout",
  inReturn: "In return",
  internal: "Internal",
  internalFx: "FX payout",
  manualCredit: "Manual credit",
  name: "Name",
  namedB2C: "Named B2C",
  noAccounts: "No accounts",
  noAccountsToSettle: "No accounts to settle",
  noAmountToSettle: "No amount to settle",
  noPayments: "No payments",
  notifications: "Notifications",
  noTransactions: "No transactions",
  noVirtualAccounts: "No virtual accounts",
  noVirtualIBANs: "No virtual IBANs",
  openLoopPayout: "Open loop payout",
  operation: "Operation",
  outgoing: "Outgoing",
  payment: "Payment",
  payments: "Payments",
  paymentScheme: "Payment scheme",
  payout: "Payout",
  pending: "Pending",
  pisPayment: "PIS payment",
  pleaseProvideNotificationURL: "Please provide notification URL",
  pleaseProvideValidNotificationURL: "Please provide valid notification URL",
  processing: "Processing",
  recalled: "Recalled",
  received: "Received",
  reference: "Reference",
  refreshAllAccounts: "Refresh all accounts",
  refund: "Refund",
  rejected: "Rejected",
  retry: "Retry",
  return: "Return",
  returned: "Returned",
  returnedManually: "Returned manually",
  reversal: "Reversal",
  reversed: "Reversed",
  selectCustomer: "Select customer",
  send: "Send",
  sender: "Sender",
  settleAccount: "Settle account",
  settleAllAccounts: "Settle all accounts",
  settlement: "Settlement",
  settlementAmountNotProvided: "Settlement amount not provided",
  settlementBalance: "Settlement balance",
  settlementOfAllAccounts: "Settlement of all accounts",
  settlementOfThisAccount: "Settlement of this account",
  sortCode: "Sort code",
  status: "Status",
  swiftCodeBic: "Swift code (BIC)",
  testNotificationHasBeenSent:
    "Test notification has been sent to {{notificationUrl}}",
  theAmountOfMoneyThatCanBeSettled: "The amount of money that can be settled",
  topUp: "Top-up",
  toViewAccountsSelectCustomer:
    "To view accounts, please select a customer in the select customer menu in the upper left corner.",
  transactionAmount: "Transaction amount",
  transactionDate: "Transaction date",
  transactionDetails: "Transaction details",
  transactions: "Transactions",
  type: "Type",
  typeOfTransaction: "Type of transaction",
  uniqueReference: "Unique reference",
  unknownType: "Unknown Type",
  valueDate: "Value date",
  vIBANused: "vIBAN used",
  viewDetails: "View details",
  virtualAccount: "Virtual account",
  virtualAccounts: "Virtual accounts",
  virtualIBANHasBeenDeactivatedSuccessfully:
    "Virtual IBAN has been deactivated successfully",
  virtualIBANs: "Virtual IBANs",
  volt: "Volt",
  voltAccounts: "Volt accounts",
  voltAccountsNotifications: "Volt accounts notifications",
  voltAccountsNotificationsSettingsHaveBeenCreated:
    "Volt accounts notifications settings have been created",
  voltAccountsNotificationsSettingsHaveBeenUpdated:
    "Volt accounts notifications settings have been updated",
  voltId: "Volt ID",
  voltPayoutId: "Volt payout ID",
  voltRefundId: "Volt refund ID",
  voltSettlementId: "Volt settlement ID",
  voltVirtualIBANIdentifierUsedForReconciliation:
    "Volt Virtual IBAN identifier used for reconciliation of credits",
  waiting: "Waiting",
  weHaveSettledYourAccount: "We have settled your account",
  withdrawal: "Withdrawal",
  youDontHaveAnyAccountsYet: "You don't have any accounts yet.",
  youDontHaveAnyPaymentsYet: "You don't have any payments yet.",
  youDontHaveAnyTransactionsYet: "You don't have any transactions yet.",
  youDontHaveAnyVIBANsYet: "You don't have any virtual IBANs yet.",
  youDontHaveAnyVirtualAccountsYet: "You don't have any virtual accounts yet.",
};
